/**
 * Returns the number of UTF-8 bytes needed to encode `input`.
 * If `input` is not a string, returns 0.
 */
export const byteLength = (input: unknown): number => {
  if (typeof input !== 'string') {
    return 0;
  }

  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(input).length;
  }

  /* extremely old browsers only: graceful fallback */
  return new Blob([input]).size; // Blob encodes as UTF-8
};
